module.exports = __webpack_public_path__ + "static/media/zoomOut.df5fbc09.svg";